import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { useFormik } from "formik";
import * as Yup from "yup";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { InputAdornment, IconButton, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import ControlPassword from "../../components/ControlPassword";
import GoogleSignInButton from "../../assets/googleButton/GoogleSignInButton";
import { useDispatch } from "react-redux";


const Step2 = ({
  handleStep,
  handleData,
  data,
  handleActiveStep2,
  invitationUid,
  login
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showControl, setShowControl] = useState(false);
  const dispatch = useDispatch()

  useEffect(() => {
    // const registerPassword = document.getElementById('register-password')
    const registerConfirmPassword = document.getElementById(
      "register-confirm-password"
    );
    // registerPassword.onpaste = e => e.preventDefault()
    registerConfirmPassword.onpaste = (e) => e.preventDefault();
  }, []);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const { t } = useTranslation();



  const formik = useFormik({
    initialValues: {
      lastName: data?.lastName,
      firstName: data?.firstName,
      email: data?.email,
      password: data?.password,
      confirmPassword: data?.confirmPassword,
    },
    validateOnMount: true,
    validationSchema: Yup.object({
      lastName: Yup.string()
        .required(t("required_field"))
        .min(3, t("short_text"))
        .matches(/^[a-zA-Z\s]*$/, t("no_special_characters")),
      firstName: Yup.string()
        .required(t("required_field"))
        .min(3, t("short_text"))
        .matches(/^[a-zA-Z\s]*$/, t("no_special_characters")),
      email: Yup.string()
        .email(t("valid_email"))
        .max(255)
        .required(t("required_field")),
      password: Yup.string()
        .max(255)
        .required(t("required_field"))
        .matches(
          /^(?=.{12,63})(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@#$%^&+=*?!-]).*$/,
          t("password_policy")
        ),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password"), null], t("match_password"))
        .required(t("required_field")),
    }),
    onSubmit: (values) => {
      handleData(values);
      handleStep();
    },
  });

  handleActiveStep2(formik.isValid);

  return (
  <div>
      <form onSubmit={formik.handleSubmit}>
      <Grid container spacing={3} sx={{ mt: 4 }}>
        <Grid item lg={6} xs={12}>
          <Typography variant="subtitle2">
            {t("surname")}
            <span style={{ color: "red" }}> *</span>
          </Typography>

          <TextField
            id="outlined-basic"
            placeholder={t("surname")}
            name="firstName"
            variant="outlined"
            disabled={invitationUid}
            fullWidth
            error={Boolean(formik.touched.firstName && formik.errors.firstName)}
            helperText={formik.touched.firstName && formik.errors.firstName}
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            value={formik.values.firstName}
          />
        </Grid>
        <Grid item lg={6} xs={12}>
          <Typography variant="subtitle2">
            {t("name")}
            <span style={{ color: "red" }}> *</span>
          </Typography>
          <TextField
            id="outlined-basic"
            placeholder={t("name")}
            name="lastName"
            disabled={invitationUid}
            variant="outlined"
            fullWidth
            error={Boolean(formik.touched.lastName && formik.errors.lastName)}
            helperText={formik.touched.lastName && formik.errors.lastName}
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            value={formik.values.lastName}
          />
        </Grid>

        <Grid item xs={12}>
          <Typography variant="subtitle2">
            {t("email_address")}
            <span style={{ color: "red" }}> *</span>
          </Typography>
          <TextField
            id="outlined-basic"
            placeholder={t("email_address")}
            variant="outlined"
            name="email"
            disabled={invitationUid}
            fullWidth
            error={Boolean(formik.touched.email && formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            value={formik.values.email}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="subtitle2">
            {t("password")}
            <span style={{ color: "red" }}> *</span>
          </Typography>
          <TextField
            id="register-password"
            placeholder={t("password")}
            name="password"
            variant="outlined"
            fullWidth
            error={Boolean(formik.touched.password && formik.errors.password)}
            helperText={formik.touched.password && formik.errors.password}
            onBlur={(e) => {
              formik.handleBlur(e);
              setShowControl(false);
            }}
            onChange={formik.handleChange}
            onFocus={() => setShowControl(true)}
            value={formik.values.password}
            type={showPassword ? "text" : "password"}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                    size="large"
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        {showControl && (
          <Grid item xs={12} sx={{ marginTop: "-25px" }}>
            <ControlPassword value={formik.values.password} />
          </Grid>
        )}
        <Grid item xs={12}>
          <Typography variant="subtitle2">
            {t("confirm_password")}
            <span style={{ color: "red" }}> *</span>
          </Typography>
          <TextField
            id="register-confirm-password"
            placeholder={t("confirm_password")}
            name="confirmPassword"
            variant="outlined"
            fullWidth
            error={Boolean(
              formik.touched.confirmPassword && formik.errors.confirmPassword
            )}
            helperText={
              formik.touched.confirmPassword && formik.errors.confirmPassword
            }
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            value={formik.values.confirmPassword}
            type="password"
          />
        </Grid>
      </Grid>

      <Button
        style={{ height: "50px", marginTop: "50px" }}
        color="secondary"
        variant="contained"
        fullWidth
        type="submit"
      >
        {t("next")}
      </Button>
    </form>
    <Grid container alignItems="center" mt={2} mb={1}>
          <Grid item xs={5}>
            <hr id="line" />
          </Grid>

          <Grid item xs={2} align="center">
            <Typography variant="subtitle2">{t("or")}</Typography>
          </Grid>
          <Grid item xs={5}>
            <hr id="line" />
          </Grid>
        </Grid>
        <Box sx={{ py: 2 }}>
          <GoogleSignInButton login={()=> login()} />
        </Box>
  </div>
    
  );
};

export default Step2;
